import React from 'react';
import { NavLink } from 'react-router-dom';


function Sidebar() {
    const imageStyle = {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        objectFit: 'contain', // Use 'contain' if you want to show the whole image
    };
    return (
        <div>
            <nav class="sidebar sidebar-offcanvas" id="sidebar">
                <div class="sidebar-brand-wrapper d-none d-lg-flex align-items-center justify-content-center fixed-top">
                    <a class="sidebar-brand brand-logo" href=""><img src="logo.png" style={imageStyle} alt=" logo" /></a>
                    <a class="sidebar-brand brand-logo-mini" href=""><img src="logo.png" style={imageStyle} alt=" logo" /></a>
                </div>
                <ul class="nav">


                    {/* <li class="nav-item menu-items px-4 py-3">
                        <NavLink to="/" className={({isActive,isPending}) => isPending ? "nav-link pending": isActive ? "nav-link active": "nav-link"}>
                            <span class="menu-icon">
                                <i class="mdi mdi-speedometer"></i>
                            </span>
                            <span class="menu-title">Home</span>
                        </NavLink>
                    </li> */}
                    <li class="nav-item menu-items px-4 py-3">
                        <NavLink to="/map" className={({ isActive, isPending }) => isPending ? "nav-link pending" : isActive ? "nav-link active" : "nav-link"}>
                            <span class="menu-icon">
                                <i class="mdi mdi-map"></i>
                            </span>
                            <span class="menu-title">Home</span>
                        </NavLink>
                    </li>

                    <li class="nav-item menu-items px-4 py-3">
                        <NavLink to="/create-bonds" className={({ isActive, isPending }) => isPending ? "nav-link pending" : isActive ? "nav-link active" : "nav-link"}>
                            <span class="menu-icon">
                                <i class="mdi mdi-table-edit"></i>
                            </span>
                            <span class="menu-title">Create Bonds</span>
                        </NavLink>

                    </li>

                    <li class="nav-item menu-items px-4 py-3">
                        <NavLink to="/portfolio" className={({ isActive, isPending }) => isPending ? "nav-link pending" : isActive ? "nav-link active" : "nav-link"}>
                            <span class="menu-icon">
                                <i class="mdi mdi-briefcase"></i>
                            </span>
                            <span class="menu-title">My Portfolio</span>
                        </NavLink>

                    </li>
                    <li class="nav-item menu-items px-4 py-3">
                        <NavLink to="/marketplace" className={({ isActive, isPending }) => isPending ? "nav-link pending" : isActive ? "nav-link active" : "nav-link"}>
                            <span class="menu-icon">
                                <i class="mdi mdi-shopping"></i>
                            </span>
                            <span class="menu-title">MarketPlace</span>
                        </NavLink>
                    </li>
                    <li class="nav-item menu-items px-4 py-3">
                        <NavLink to="/usdc-testnet-faucet" className={({ isActive, isPending }) => isPending ? "nav-link pending" : isActive ? "nav-link active" : "nav-link"}>
                            <span class="menu-icon">
                                <i class="mdi mdi-currency-usd"></i>
                            </span>
                            <span class="menu-title">USDC Faucet</span>
                        </NavLink>
                    </li>


                </ul>
            </nav>


        </div>
    );
}


export default Sidebar